import axios from "axios";
import { showAlert, showConfirm, handleRequestError } from "../../utils/alert";

export default () => ({
  activeTab: "hours",
  isSubmitting: false,

  // --- Estado: Horários (INICIALIZADO PARA NÃO QUEBRAR O ALPINE) ---
  businessHours: {
    monday: { is_open: false, open: "09:00", close: "18:00" },
    tuesday: { is_open: true, open: "09:00", close: "19:00" },
    wednesday: { is_open: true, open: "09:00", close: "19:00" },
    thursday: { is_open: true, open: "09:00", close: "19:00" },
    friday: { is_open: true, open: "09:00", close: "19:00" },
    saturday: { is_open: true, open: "09:00", close: "15:00" },
    sunday: { is_open: false, open: "09:00", close: "13:00" },
  },

  daysOfWeek: [
    { key: "monday", label: "Segunda-feira" },
    { key: "tuesday", label: "Terça-feira" },
    { key: "wednesday", label: "Quarta-feira" },
    { key: "thursday", label: "Quinta-feira" },
    { key: "friday", label: "Sexta-feira" },
    { key: "saturday", label: "Sábado" },
    { key: "sunday", label: "Domingo" },
  ],

  // --- Estado: Bloqueios ---
  blocksList: [],
  blockForm: { date: "", start_time: "09:00", end_time: "12:00", reason: "" },
  isModalOpen: false, // Voltamos ao padrão de nome do modal

  async initScheduleSettings() {
    const token = localStorage.getItem("jwt_token");
    if (!token) {
      window.location.href = "/client/login";
      return;
    }
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
      await this.fetchBusinessHours();
      await this.fetchBlocks();
    } catch (error) {
      // Captura o erro 403 e bloqueia a view
      if (error.response && error.response.status === 403) {
        this.hasAccessModule = false;
        return;
      }

      // Ignora se for problema de autenticação/pagamento (tratado pelo interceptor global)
      if (error.response && [401, 402].includes(error.response.status)) return;

      console.error("Infrastructure error:", error);
    }
  },

  // ================= HORÁRIOS =================
  async fetchBusinessHours() {
    try {
      // Correção: Apontar para a API do Cliente (Tenant)
      const response = await axios.get(
        "/api/client/schedule-settings/business-hours",
      );
      if (response.data.data) {
        this.businessHours = response.data.data;
      }
    } catch (error) {
      console.error("Erro ao carregar horários", error);
    }
  },

  async saveBusinessHours() {
    this.isSubmitting = true;
    try {
      // Correção: Apontar para a API do Cliente (Tenant)
      await axios.put(
        "/api/client/schedule-settings/business-hours",
        this.businessHours,
      );
      showAlert("Horários salvos com sucesso!", "success");
    } catch (error) {
      handleRequestError(error, "Erro ao guardar horários.");
    } finally {
      this.isSubmitting = false;
    }
  },

  // ================= HORÁRIOS =================
  async fetchBusinessHours() {
    try {
      // Correção: Apontar para a API do Cliente (Tenant)
      const response = await axios.get(
        "/api/client/schedule-settings/business-hours",
      );
      if (response.data.data) {
        this.businessHours = response.data.data;
      }
    } catch (error) {
      console.error("Erro ao carregar horários", error);
    }
  },

  async saveBusinessHours() {
    this.isSubmitting = true;
    try {
      // Correção: Apontar para a API do Cliente (Tenant)
      await axios.put(
        "/api/client/schedule-settings/business-hours",
        this.businessHours,
      );
      showAlert("Horários salvos com sucesso!", "success");
    } catch (error) {
      handleRequestError(error, "Erro ao guardar horários.");
    } finally {
      this.isSubmitting = false;
    }
  },

  // ================= BLOQUEIOS =================
  async fetchBlocks() {
    try {
      // Correção: Apontar para a API do Cliente (Tenant)
      const response = await axios.get("/api/client/schedule-settings/blocks");
      this.blocksList = response.data.data;
    } catch (error) {
      console.error(error);
    }
  },

  openCreateBlock() {
    this.blockForm = {
      date: "",
      start_time: "09:00",
      end_time: "12:00",
      reason: "",
    };
    this.isModalOpen = true;
  },

  async submitBlock() {
    this.isSubmitting = true;
    try {
      // Correção: Apontar para a API do Cliente (Tenant)
      await axios.post("/api/client/schedule-settings/blocks", this.blockForm);
      showAlert("Agenda bloqueada com sucesso!", "success");
      await this.fetchBlocks();
      this.isModalOpen = false;
    } catch (error) {
      handleRequestError(error, "Erro ao criar bloqueio.");
    } finally {
      this.isSubmitting = false;
    }
  },

  async deleteBlock(id) {
    const result = await showConfirm(
      "Remover Bloqueio",
      "Deseja liberar este horário na agenda?",
    );
    if (result.isConfirmed) {
      try {
        // Correção: Apontar para a API do Cliente (Tenant)
        await axios.delete(`/api/client/schedule-settings/blocks/${id}`);
        await this.fetchBlocks();
        showAlert("Bloqueio removido.", "success");
      } catch (error) {
        handleRequestError(error, "Erro ao remover.");
      }
    }
  },
});
